module.exports = __webpack_public_path__ + "img/parche__corregido_EN.670bcd87.png";